import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
interface CountdownProps {
  label?: string;
  compact?: boolean;
}
function pad(n: number): string {
  return n.toString().padStart(2, '0');
}
export function Countdown({
  label,
  compact = false
}: CountdownProps) {
  const [seconds, setSeconds] = useState(23 * 3600 + 50 * 60 + 5);
  useEffect(() => {
    const id = setInterval(() => {
      setSeconds(s => s > 0 ? s - 1 : 0);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor(seconds % 3600 / 60);
  const secs = seconds % 60;
  const box = 'flex flex-col items-center justify-center rounded-lg border border-[var(--lilac)]/40 bg-black px-3 py-2 min-w-[56px] sm:min-w-[68px]';
  return <div className="flex flex-col items-center gap-3" data-id="element-42" data-mp="10btp3yi6liwb">
      {label && <p className="flex items-center gap-2 text-sm font-semibold uppercase tracking-widest text-[var(--lilac-light)]" data-id="element-43" data-mp="10aii7ptfvv0z">
          <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-44" data-mp="y0n1tq0onbb3" />
          {label}
        </p>}
      <div className="flex items-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`Tiempo restante ${hrs} horas ${mins} minutos ${secs} segundos`} data-id="element-45" data-mp="t2lkpamthm29">
        {[{
        v: hrs,
        l: 'hs'
      }, {
        v: mins,
        l: 'min'
      }, {
        v: secs,
        l: 'seg'
      }].map((unit, i) => <React.Fragment key={unit.l} data-id="element-46" data-mp="f2u9tirlklsh" data-mpi={i}>
            <div className={box} data-id="element-47" data-mp="a37o0kxpdx82">
              <span className={`font-display font-extrabold leading-none text-[var(--cream)] ${compact ? 'text-2xl sm:text-3xl' : 'text-3xl sm:text-4xl'}`} data-id="element-48" data-mp="a49armo3085m">
                {pad(unit.v)}
              </span>
              <span className="mt-1 text-[10px] font-semibold uppercase tracking-wider text-white/50" data-id="element-49" data-mp="1zhw0sna7hh6m">
                {unit.l}
              </span>
            </div>
            {i < 2 && <span className="text-2xl font-bold text-[var(--lilac)]" data-id="element-50" data-mp="s5wvqmt8vvga">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}